import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireAdmin?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAuth = true,
  requireAdmin = false
}) => {
  const { isAuthenticated, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (requireAuth && !isAuthenticated && !loading) {
      const path = location.pathname + location.search;
      if (!path.includes('/login')) {
        localStorage.setItem('redirectAfterLogin', path);
      }
      navigate('/login', { replace: true });
    } else if (requireAdmin && isAuthenticated && user && !user.isAdmin && !loading) {
      // Rediriger vers la page d'accueil si l'utilisateur n'est pas admin
      navigate('/', { replace: true });
    }
  }, [requireAuth, requireAdmin, isAuthenticated, user, loading, navigate, location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-2"></div>
          <p className="text-sm text-gray-600">Vérification...</p>
        </div>
      </div>
    );
  }

  // 🚀 IMPORTANT : si pas auth → NE PAS rendre children
  if (requireAuth && !isAuthenticated) return null;

  // 🔒 IMPORTANT : si requireAdmin mais pas admin → NE PAS rendre children
  if (requireAdmin && (!user || !user.isAdmin)) return null;

  return <>{children}</>;
};

export default ProtectedRoute;
